/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { AppService } from '../../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { HomeService } from '../../home.service';
import { AbInfoPopupService } from '../../services/ab-info-popup.service';
import { ProjectsService } from '../../services/project.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-infopopup',
  templateUrl: './infopopup.component.html',
  styleUrls: ['./infopopup.component.scss']
})
export class InfopopupComponent {
  isOnMobilePlatform = false;
  // showCatTypePopUp = true;
  isabpopupinfo:any;

  constructor(@Inject(PLATFORM_ID) private platformId: any, public _as: AppService, public router: Router, public _ar: ActivatedRoute,
  public title: Title,public meta:Meta,  public _hs: HomeService,public _abpopupinfo:AbInfoPopupService,public _project: ProjectsService,) {
    if(isPlatformBrowser(platformId)){
  this.isOnMobilePlatform = this._as.isOnMobilePlatform;
    }
}
// showCatTypePopUp(): void{
//   this.showCatTypePopUp =false;
// }
closecorepopup(){
  // if(!this._as.isOnMobilePlatform){
    this._abpopupinfo.visibleInfoPopup=false;
  // }
}
goSmartsearch(){
this.router.navigate(['smart-search'])
  this._abpopupinfo.visibleInfoPopup= false;
}
}
